const keyText = (v) => (v == null ? '' : typeof v === 'string' ? v.trim().toUpperCase() : String(v));
export function crossRowErrors(ds, rows, o) {
    const out = [], seen = new Set();
    const hdr = (c) => o.header?.(c) ?? c;
    // 같은 칸에 여럿이면 처음 것 — 다만 더 높은 수준(오류)이 뒤에 오면 그것으로 바꿈
    const rank = (l) => (l === 'info' ? 1 : l === 'warning' ? 2 : 3);
    const at = new Map();
    const push = (e) => {
        const k = e.row + ':' + e.col;
        if (seen.has(k)) {
            const i = at.get(k);
            if (rank(e.level) > rank(out[i].level))
                out[i] = e;
            return;
        }
        seen.add(k);
        at.set(k, out.length);
        out.push(e);
    };
    const lv = (l) => (l === 'warning' || l === 'info' ? { level: l } : {});
    const ub = (o.uniqueBy ?? []).filter(c => ds.hasColumn(c));
    if (ub.length) {
        const groups = new Map();
        for (let i = 0; i < rows.length; i++) {
            const r = rows[i], parts = ub.map(c => keyText(ds.get(r, c)));
            if (parts.every(p => p === ''))
                continue; // 빈 값끼리는 중복으로 보지 않음 (아직 입력 전)
            const k = parts.join('\u0001'), g = groups.get(k);
            if (g)
                g.push(r);
            else
                groups.set(k, [r]);
        }
        const label = ub.map(hdr).join('·');
        for (const [k, g] of groups) {
            if (g.length < 2)
                continue;
            const shown = k.split('\u0001').filter(Boolean).join('·');
            for (const r of g)
                for (const c of ub)
                    push({ row: r, col: c, message: `${label} ${shown} 이(가) ${g.length}건 중복입니다`, ...lv(o.uniqueByLevel) });
        }
    }
    const sums = o.maxSum == null ? [] : Array.isArray(o.maxSum) ? o.maxSum : [o.maxSum];
    for (const s of sums) {
        if (!ds.hasColumn(s.col) || !(s.max === s.max))
            continue;
        let sum = 0;
        const contrib = [];
        for (let i = 0; i < rows.length; i++) {
            const v = ds.get(rows[i], s.col);
            if (v == null || v === '')
                continue;
            const n = Number(v);
            if (n !== n)
                continue;
            sum += n;
            if (n !== 0)
                contrib.push(rows[i]);
        }
        sum = Math.round(sum * 1e9) / 1e9;
        if (sum > s.max) {
            const msg = s.message ? s.message.replace('{sum}', String(sum)).replace('{max}', String(s.max)) : `${hdr(s.col)} 합계 ${sum} 이(가) 한도 ${s.max} 을(를) 넘습니다`;
            for (const r of contrib)
                push({ row: r, col: s.col, message: msg, ...lv(s.level) });
        }
    }
    if (o.validateRows) {
        const extra = o.validateRows(ds, rows);
        if (Array.isArray(extra))
            for (const e of extra)
                if (e && e.row >= 0 && e.col && e.message)
                    push({ row: e.row, col: e.col, message: String(e.message), ...lv(e.level) });
    }
    return out;
}
